import classNames from 'classnames'

import type { LinkType } from 'types'
import Button from 'content-components/_Primatives/Button'
import Paragraph from 'content-components/_Primatives/Paragraph'
import TextBlock from 'ui-component-library/components/00-Primitives/TextBlock'
import style from './style.scss'

type Props = {
  className?: string
  contactText?: string
  isAvailable: boolean
  isWaitlisted: boolean
  registerLink: LinkType
  registrationOpenStatusText: string
  registrationPrice?: string
  registrationStatusLabelText?: string
  registrationText: string
  registrationWaitingStatusText: string
  revalidationPrice?: string
  revalidationText: string
  registerButtonText: string
  languageText?: string
}

function EventCard(props: Props) {
  const {
    className,
    contactText,
    isAvailable,
    isWaitlisted,
    registerLink,
    registrationOpenStatusText,
    registrationPrice,
    registrationStatusLabelText,
    registrationText,
    registrationWaitingStatusText,
    revalidationPrice,
    revalidationText,
    registerButtonText,
    languageText,
  } = props

  const registrationStatus = isWaitlisted ? 'waiting' : 'open'
  const statusText = {
    open: registrationOpenStatusText,
    waiting: registrationWaitingStatusText,
  }

  return (
    <div className={classNames(style.wrapper, className)}>
      <div
        className={classNames(
          style.registrationStatus,
          style[registrationStatus],
        )}
      >
        <span
          className={style.hideStatusLabel}
        >{`${registrationStatusLabelText} `}</span>
        {statusText[registrationStatus]}
      </div>
      <div className={style.details}>
        <Paragraph className={style.registrationPricing} small>
          {registrationPrice ? (
            <>
              {`${registrationText} `}
              <span className={style.registrationCost}>
                {registrationPrice}
              </span>
            </>
          ) : (
            ''
          )}
          {revalidationPrice && (
            <>
              <br />
              {`${revalidationText} `}
              <span className={style.registrationCost}>
                {revalidationPrice}
              </span>
            </>
          )}
        </Paragraph>

        {languageText && <Paragraph small>{languageText}</Paragraph>}

        {isAvailable && !isWaitlisted && (
          <Button url={registerLink.url}>{registerButtonText}</Button>
        )}
        {contactText && (
          <TextBlock className={style.textBlock}>{contactText}</TextBlock>
        )}
      </div>
    </div>
  )
}

export default EventCard
